// import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { TableSortLabel } from "@mui/material";
import classNames from "classnames";
import { SmallBody } from "helpers/TypographyComponents";

import Template from "./Row/Template";
import type { TableColumn, TableSortOptions } from "./types";

export interface IHead {
    columns: TableColumn[];
    tableLabel?: string;
    sortedColumn?: string;
    sortDirection?: "asc" | "desc";
    sort?: TableSortOptions;
    onColumnClick?: (args: { id: string }) => void;
}

function Head(props: IHead) {
    return (
        <thead className="z-[11]">
            <Template
                columns={props.columns}
                cells={props.columns.map((column) => ({
                    columnId: column.id,
                    value: "",
                }))}
                className={classNames(
                    "py-2! bg-[#F6F6F6]! border-[1px]! border-[#eaeaea]! rounded-[3px]! overflow-hidden!",
                )}
                renderCell={({ column }) => {
                    return (
                        // <div className={classNames("border-[1px]! border-blue-500! flex size-full items-end")}>
                        //     <SmallBody
                        //         className={classNames(
                        //             "border-[1px]! border-red-500!",
                        //             "flex-1 min-w-0 font-poppins! text-[#676767]! line-clamp-2 px-1!",
                        //         )}
                        //     >
                        //         {column.label}
                        //     </SmallBody>
                        //     <ArrowDownwardIcon className="flex-none" fontSize="small" />
                        // </div>
                        <TableSortLabel
                            active={props.sort?.column === column.id}
                            direction={props.sort?.direction}
                            onClick={() => props.onColumnClick?.({ id: column.id })}
                            className={classNames("max-w-full!", {
                                "[&>svg]:-left-[20px] [&>svg]:right-auto!": column.align === "right",
                            })}
                        >
                            <SmallBody
                                className={classNames(
                                    "font-poppins! text-[#676767]! whitespace-nowrap text-ellipsis overflow-hidden pl-1!",
                                )}
                            >
                                {column.label}
                            </SmallBody>
                        </TableSortLabel>
                    );
                }}
            />
        </thead>
    );
}

export default Head;
